declare var STATIC_BASE_URL:string;

import '../styles/contacts.scss';

import { h, Component } from 'preact';
import nl2br from './nl2br';
import Illustration from './illustration';

export default class Contacts extends Component<any, any> {

  private offices: any;

  constructor() {
    super();

    this.offices = [
      {
        city: 'New York',
        img: 'new-york',
        address: '145 West 27TH Street, suite 6E, New York, 10001, United States of America'
      }, {
        city: 'Florence',
        img: 'florence',
        address: `Via Bernardo Daddi 19,
                  50143 Florence, Italy`
      }, {
        city: 'Dubai',
        img: 'dubai',
        address: `Office 404, Building B
                  Al Saaha Offices
                  Souk Al Bahar, Old Town Island
                  Burj Khalifa District
                  PO Box 487177, Dubai - United Arab Emirates`
      }, {
        city: 'Taiwan',
        img: 'taipei',
        address: `Changhua County,
                  Erlin Township,
                  Jiuer Rd. ln. 160, nr. 47`
      }
    ];
  }

  public render(props, state): any {

    const offices = this.offices.map( d => <li>
      <img src={ STATIC_BASE_URL + 'images/public/office-' + d.img + '.jpg'} alt={ d.city + ' Office' } />
      <div>
        <h3>{ d.city }</h3>
        <p>
          { nl2br(d.address) }
        </p>
        { d.phone ? <p><a href="tel:{ d.phone.number }">{ d.phone.descr }</a></p> : '' }
      </div>
    </li>);

    return <div id="contacts">
      <div class="mainWrp">
        <section class="body center">
          <h1>Contact Us</h1>
          <h2 class="content">
            Send us an <a href="mailto:info@querlo.com">email</a>, or interact with our chatbot.<br />We will get back to you the soonest.
          </h2>
          <p class="center calltoaction"><a href="mailto:info@querlo.com" class="butt huge">Get in Touch</a></p>
        </section>
      </div>
      <section class="full grey">
        <div class="phoneWrp">
          <div class="iframeWrp">
            <div></div>
            <iframe frameBorder="0" src="https://www.querlo.com/chat/7105"></iframe>
          </div>
          <Illustration src={ STATIC_BASE_URL + 'images/public/iphonexminimal' } alt="phone chat wrapper" />
        </div>
      </section>
      <div class="mainWrp">
        <section class="body">
          <h2>Our Offices</h2>
          <ul>

            { offices }

          </ul>
        </section>
      </div>
    </div>
  }
}


// WEBPACK FOOTER //
// ./ts/Contacts.tsx